import React from 'react';
import Typography from '@mui/material/Typography';
import useIsMobile from '../hooks/useIsMobile';
import { useThemeCustomStyles } from '../hooks/useThemeConfig';

function InputLabel({ title }) {
  const small = useIsMobile();
  const styles = useThemeCustomStyles();
  const labelStyle = styles.InputLabel(small);
  return (
  	<Typography 
		variant={small ? 'caption' : 'h6'} 
		sx={labelStyle}
	>
		{title}
  	</Typography>
  );
}

export default InputLabel;
